// src/components/BookingPreview.jsx — ФИНАЛЬНАЯ ВЕРСИЯ ДЛЯ МОБИЛЬНЫХ
import React from 'react';
import {X} from 'lucide-react';

export default function BookingPreview({booking, onClose}) {
    let b = [];
    if (!booking) {
        return null;
    } else {
        b = booking[0];
    }

    const checkIn = new Date(b.Date_In);
    const checkOut = new Date(b.Date_Out);
    const nights = Math.ceil((checkOut - checkIn) / (1000 * 60 * 60 * 24));

    const formatDate = (date) => {
        return date.toLocaleDateString('ru-RU', {
            day: 'numeric',
            month: 'long',
            year: 'numeric'
        });
    };

    return (
        <>
            {/* Тёмный оверлей */}
            <div
                className="fixed inset-0 bg-black/30 backdrop-blur-sm z-40"
                onClick={onClose}
            />

            {/* Карточка с безопасными отступами */}
            <div
                className="fixed inset-0 z-50 flex items-center justify-center px-4 pointer-events-none"
                style={{
                    paddingTop: 'env(safe-area-inset-top)',
                    paddingBottom: 'env(safe-area-inset-bottom)'
                }}
            >
                <div className="w-full max-w-md pointer-events-auto">
                    <div
                        className="
        bg-white/98 backdrop-blur-2xl rounded-3xl shadow-2xl border border-gray-200
        overflow-hidden animate-in slide-in-from-bottom duration-500

        max-h-[80svh]     /* горизонтальная ориентация / любые маленькие экраны */
        sm:max-h-[85svh]  /* портретная ориентация телефонов */
        md:max-h-[90vh]   /* планшеты */

        overflow-y-auto
    "
                    >
                        {/* Цветная полоска сверху */}
                        <div className="h-2 bg-gradient-to-r from-orange-400 to-pink-500"></div>

                        <div className="p-6">
                            <div className="flex items-start justify-between mb-4">
                                <div className="flex items-center gap-4">
                                    <div
                                        className="w-14 h-14 bg-gray-900 text-white rounded-full flex items-center justify-center text-2xl font-bold shadow-xl">
                                        {b.rooms_id}
                                    </div>
                                    <div>
                                        <h3 className="text-2xl font-bold text-gray-900 leading-tight">
                                            {b.Client_Name}
                                        </h3>
                                        <p className="text-sm text-gray-500">Номер {b.rooms_id}</p>
                                    </div>
                                </div>

                                <button
                                    onClick={onClose}
                                    className="text-gray-400 hover:text-gray-700 transition p-2 -mr-2"
                                >
                                    <X size={28} strokeWidth={2.5}/>
                                </button>
                            </div>

                            <div className="grid grid-cols-2 gap-6 py-3 border-t border-gray-100">
                                <div>
                                    <p className="text-sm text-gray-500">Заезд</p>
                                    <p className="text-lg font-semibold text-gray-900">
                                        {formatDate(checkIn)}
                                    </p>
                                </div>
                                <div>
                                    <p className="text-sm text-gray-500">Отъезд</p>
                                    <p className="text-lg font-semibold text-red-600">
                                        {formatDate(checkOut)}
                                    </p>
                                </div>
                            </div>

                            <div className="text-center pt-2">
                <span className="inline-block px-6 py-3 bg-orange-100 text-orange-700 rounded-full font-bold text-sm">
                  {nights} {nights === 1 ? 'ночь' : nights < 5 ? 'ночи' : 'ночей'}
                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    );
}
